import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Commerce: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 42 42"
    sx={{
      width: '42px',
      height: '42px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M10.4492 11.5938L9.282 6.34375H5.90625"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5288 25.9613L10.4453 11.5938H32.5968C33.7116 11.5938 34.5411 12.621 34.3083 13.7113L31.6798 25.9613C31.5066 26.768 30.7943 27.3438 29.9683 27.3438H15.2386C14.4143 27.3438 13.7021 26.768 13.5288 25.9613Z"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.5668 33.6875C30.2046 33.6875 29.9106 33.9815 29.9141 34.3438C29.9141 34.706 30.2081 35 30.5703 35C30.9326 35 31.2266 34.706 31.2266 34.3438C31.2248 33.9815 30.9308 33.6875 30.5668 33.6875"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4974 33.6875C15.1351 33.6875 14.8411 33.9815 14.8446 34.3438C14.8429 34.706 15.1369 35 15.4991 35C15.8614 35 16.1554 34.706 16.1554 34.3438C16.1554 33.9815 15.8614 33.6875 15.4974 33.6875"
      stroke="#B4EB56"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const CommerceDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 42 42"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path
      d="M10.4492 11.5938L9.282 6.34375H5.90625"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5288 25.9613L10.4453 11.5938H32.5968C33.7116 11.5938 34.5411 12.621 34.3083 13.7113L31.6798 25.9613C31.5066 26.768 30.7943 27.3438 29.9683 27.3438H15.2386C14.4143 27.3438 13.7021 26.768 13.5288 25.9613Z"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.5668 33.6875C30.2046 33.6875 29.9106 33.9815 29.9141 34.3438C29.9141 34.706 30.2081 35 30.5703 35C30.9326 35 31.2266 34.706 31.2266 34.3438C31.2248 33.9815 30.9308 33.6875 30.5668 33.6875"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4974 33.6875C15.1351 33.6875 14.8411 33.9815 14.8446 34.3438C14.8429 34.706 15.1369 35 15.4991 35C15.8614 35 16.1554 34.706 16.1554 34.3438C16.1554 33.9815 15.8614 33.6875 15.4974 33.6875"
      stroke="#090C18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
